import { Breadcrumb, Button, Card, Col, Flex, Row, Space, TimePicker } from "antd";
import { useForm } from "antd/es/form/Form";
import FormItem from "antd/es/form/FormItem";
import { FormInput, FormSelect } from "components/form/FormProvide";
import FormAntd from "components/form/FormProvide/FormAntd";
import FormSwitch from "components/form/FormProvide/FormSwitch";
import { MainLayout } from "components/layouts";
import { useTranslation } from "react-i18next";
import { ReactComponent as CreateIcon } from "../../../assets/icon/createIcon.svg";
import FormTimePicker from "components/form/FormProvide/FormTimePicker";
import EmployeeList from "./EmployeeList";
import SendNotiToModal from "./SendNotiToModal";

const CreateNotifySetting = ({
    modifiedLeaveOptions = [],
    modifiedDepartmentOption = [],
    modifiedPositionOptions = [],
    modifiedBranchOptions = [],
    modifiedShiftOptions = [],
    isModalOpen = false,
    setIsModalOpen = () => { },
}) => {
    const { t, i18n } = useTranslation();
    const [form] = useForm()

    return (
        <MainLayout>
            <SendNotiToModal isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} />
            <Space size={24} direction="vertical" style={{ width: "100%" }}>
                <Flex vertical>
                    <Breadcrumb items={[
                        { title: t("home.header"), href: "/" },
                        { title: t("masterdata.header"), href: "" },
                        { title: t("setting_notification.header"), href: "" },
                        { title: t("setting_notification.label.notify"), href: "" },
                        { title: t("common.create") },
                    ]} />

                </Flex>

                <Card style={{
                    backgroundColor: "white",
                    width: "100%",
                    boxShadow: '0px 4px 2px 0px rgba(0, 0, 0, 0.15)',
                    borderRadius: "20px"
                }}>
                    <FormAntd
                        form={form}
                    // onFinish={onSubmit}
                    >
                        <FormItem shouldUpdate>
                            {({ getFieldsValue, getFieldValue, setFieldValue }) => {
                                return (
                                    <Space size={32} direction="vertical" style={{ width: "100%" }}>
                                        <Flex vertical gap={16}>
                                            <Flex vertical>
                                                <h2>{t("setting_notification.create")}</h2>
                                                <span style={{ color: "#667085" }}>{t("setting_notification.detail")}</span>
                                            </Flex>

                                            <Row justify="space-between">
                                                <Col span={7}>
                                                    <FormInput
                                                        name="groupName"
                                                        label={t("notify_setting.group_name")}
                                                        placeholder={t("please-enter")}
                                                        size="large"
                                                        required
                                                        allowClear
                                                    />
                                                </Col>
                                                <Col span={7}>
                                                    <FormSelect
                                                        name="branchListId"
                                                        label={t("branch.header")}
                                                        placeholder={t("common.pleaseSelect")}
                                                        size="large"
                                                        mode="multiple"
                                                        options={modifiedBranchOptions}
                                                        allowClear
                                                    />
                                                </Col>
                                                <Col span={7}>
                                                    <FormSelect
                                                        name="departmentListId"
                                                        label={t("employee.label.department")}
                                                        placeholder={t("common.pleaseSelect")}
                                                        size="large"
                                                        options={modifiedDepartmentOption}
                                                        tree={true}
                                                        multiple={true}
                                                    />
                                                </Col>
                                            </Row>
                                            <Row justify="space-between">
                                                <Col span={7}>
                                                    <FormSelect
                                                        name="positionListId"
                                                        label={t("home.position")}
                                                        placeholder={t("common.pleaseSelect")}
                                                        size="large"
                                                        options={modifiedPositionOptions}
                                                        tree={true}
                                                        multiple={true}
                                                    />
                                                </Col>
                                                <Col span={7}>
                                                    <FormSelect
                                                        name="shiftId"
                                                        label={t("shift.header")}
                                                        placeholder={t("common.pleaseSelect")}
                                                        size="large"
                                                        options={modifiedShiftOptions}
                                                        allowClear
                                                    />
                                                </Col>
                                                <Col span={7}></Col>
                                            </Row>
                                        </Flex>

                                        <Flex vertical gap={16}>
                                            <Flex vertical>
                                                <h2>{t("setting_notification.noti_condition")}</h2>
                                                <span style={{ color: "#667085" }}>{t("setting_notification.detail_condition")}</span>
                                            </Flex>

                                            <Flex vertical>
                                                <Row align={"middle"}>
                                                    <Col span={i18n.language == "en" ? 6 : 5}>
                                                        <span style={{ color: "#42526D", fontWeight: "bold" }}>{t("notify_setting.summary_attendance")}</span>
                                                    </Col>
                                                    <Col span={2}>
                                                        <FormSwitch name="summaryTimeStamp"
                                                            onChange={(checked) => {
                                                                setFieldValue("summaryTimeStamp", checked);
                                                                if (!checked) {
                                                                    setFieldValue("frequencyOfNotification", null);
                                                                    setFieldValue("firstNoti", null);
                                                                    setFieldValue("secondNoti", null);
                                                                    setFieldValue("thirdNoti", null);
                                                                }
                                                            }}
                                                        />
                                                    </Col>
                                                </Row>

                                                {getFieldValue("summaryTimeStamp") && (
                                                    <Flex vertical >
                                                        <Col span={7} style={{ marginBottom: "16px" }}>
                                                            <FormSelect
                                                                name="frequencyOfNotification"
                                                                label={t("notify_setting.noti_frequency")}
                                                                placeholder={t("please-enter")}
                                                                size="large"
                                                                required
                                                                options={[
                                                                    { value: '1', label: `1 ${t("times")}` },
                                                                    { value: '2', label: `2 ${t("times")}` },
                                                                    { value: '3', label: `3 ${t("times")}` },
                                                                ]}
                                                                onChange={(value) => {
                                                                    setFieldValue("frequencyOfNotification", value);
                                                                    setFieldValue("firstNoti", null);
                                                                    setFieldValue("secondNoti", null);
                                                                    setFieldValue("thirdNoti", null);
                                                                }}
                                                            />
                                                        </Col>

                                                        <Row justify={"space-between"} style={{ marginBottom: "16px" }}>
                                                            {getFieldValue("frequencyOfNotification") && (
                                                                <Col span={7}>
                                                                    <FormTimePicker
                                                                        name="firstNoti"
                                                                        label={t("notify_setting.first_noti")}
                                                                        placeholder={t("please-enter")}
                                                                        size="large"
                                                                        required
                                                                    />
                                                                </Col>
                                                            )}
                                                            {(getFieldValue("frequencyOfNotification") === "2" || getFieldValue("frequencyOfNotification") === "3") && (
                                                                <>
                                                                    <Col span={7}>
                                                                        <FormTimePicker
                                                                            name="secondNoti"
                                                                            label={t("notify_setting.second_noti")}
                                                                            placeholder={t("please-enter")}
                                                                            size="large"
                                                                            required
                                                                        />
                                                                    </Col>
                                                                </>
                                                            )}

                                                            {(getFieldValue("frequencyOfNotification") === "2") && (
                                                                <Col span={7}></Col>
                                                            )}

                                                            {(getFieldValue("frequencyOfNotification") === "3") && (
                                                                <Col span={7}>
                                                                    <FormTimePicker
                                                                        name="thirdNoti"
                                                                        label={t("notify_setting.third_noti")}
                                                                        placeholder={t("please-enter")}
                                                                        size="large"
                                                                        required
                                                                    />
                                                                </Col>
                                                            )}
                                                        </Row>
                                                    </Flex>
                                                )}

                                                <Row>
                                                    <Col span={i18n.language == "en" ? 6 : 5}>
                                                        <span style={{ color: "#42526D", fontWeight: "bold" }}>{t("notify_setting.realTime_attendance")}</span>
                                                    </Col>
                                                    <Col span={2}>
                                                        <FormSwitch name="timeStampFlag" />
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col span={i18n.language == "en" ? 6 : 5}>
                                                        <span style={{ color: "#42526D", fontWeight: "bold" }}>{t("notify_setting.realTime_request")}</span>
                                                    </Col>
                                                    <Col span={2}>
                                                        <FormSwitch
                                                            name="myRequestFlag"
                                                            onChange={(checked) => {
                                                                setFieldValue("myRequestFlag", checked);
                                                                if (!checked) {
                                                                    setFieldValue("requestType", null);
                                                                }
                                                            }}
                                                        />
                                                    </Col>
                                                </Row>
                                                {getFieldValue("myRequestFlag") && (
                                                    <Col span={7}>
                                                        <FormSelect
                                                            name="requestType"
                                                            label={t("request_all.request_type")}
                                                            placeholder={t("please-select")}
                                                            size="large"
                                                            required
                                                            options={modifiedLeaveOptions}
                                                        />
                                                    </Col>
                                                )}

                                            </Flex>
                                        </Flex>

                                        <Flex vertical gap={16}>
                                            <Flex vertical>
                                                <h2>{t("setting_notification.send_to")}</h2>
                                                <span style={{ color: "#667085" }}>{t("setting_notification.detail_send_to")}</span>
                                            </Flex>
                                            <Button
                                                type="primary"
                                                style={{ height: "40px", width: "fit-content", borderRadius: "8px", display: "flex", alignItems: "center", backgroundColor: "var(--button-color)" }}
                                                icon={<CreateIcon style={{ fontSize: 16 }} />}
                                                onClick={() => { setIsModalOpen(true) }}
                                            >
                                                {t("employee.label.add")}
                                            </Button>

                                            <EmployeeList />
                                        </Flex>
                                    </Space>
                                )
                            }}
                        </FormItem>
                    </FormAntd>

                    <Row justify="end" style={{ gap: "12px", paddingTop: "48px" }}>
                        <Button type="default"
                            style={{ height: "40px", borderRadius: "8px", color: "#565656", fontWeight: "bold" }}
                        >
                            {t("common.cancel").toUpperCase()}
                        </Button>

                        <Button type="primary"
                            style={{ height: "40px", borderRadius: "8px", backgroundColor: "var(--button-color)", color: "white", fontWeight: "bold" }}
                        >
                            {t("common.submit").toUpperCase()}
                        </Button>
                    </Row>
                </Card>
            </Space>
        </MainLayout>
    )
}

export default CreateNotifySetting;